var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.digitType.length >= 1
    ? _c(
        "div",
        {
          staticClass: "col-12 px-0",
        },
        [
          _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "290",
              },
              model: {
                value: _vm.dialog,
                callback: function ($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass: "text-h6 text-center",
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.dialog_message) + "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "green darken-1",
                            text: "",
                          },
                          on: {
                            click: function ($event) {
                              ;(_vm.dialog = false), (_vm.deldigit = false)
                            },
                          },
                        },
                        [_vm._v("\n          ยกเลิก\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "red darken-1",
                            text: "",
                          },
                          on: {
                            click: function ($event) {
                              ;(_vm.dialog = false), _vm.specialButtonDel()
                            },
                          },
                        },
                        [_vm._v("\n          ยืนยัน\n        ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass: "w-100",
              attrs: {
                id: "shoot",
                method: "POST",
              },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.onSubmit.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "d-flex",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex-width",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "form-group",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.digitValue,
                                expression: "digitValue",
                              },
                            ],
                            staticClass:
                              "form-control text-center text-lg disabled",
                            attrs: {
                              required: "required",
                              name: "digit",
                              disabled: "disabled",
                              type: "tel",
                              placeholder: _vm.placeHolder,
                              maxlength: _vm.digitValueSet,
                              minlength: _vm.digitValueSet,
                            },
                            domProps: {
                              value: _vm.digitValue,
                            },
                            on: {
                              keypress: function ($event) {
                                return _vm.validateNumber($event)
                              },
                              paste: function ($event) {
                                return _vm.onPaste($event)
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.digitValue = $event.target.value
                              },
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.digitValueSet > 1
                ? _c(
                    "div",
                    {
                      staticClass: "d-flex",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "w-100 btn btn-outline-dark mb-1",
                          class: {
                            active: _vm.shuffleDigit,
                          },
                          on: {
                            click: _vm.shuffleButton,
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fas fa-random mr-2",
                          }),
                          _vm._v(" สลับเลข\n      "),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex-width my-1",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-yellow w-100",
                          attrs: {
                            type: "button",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.digitClick(1)
                            },
                          },
                        },
                        [_vm._v("\n          1\n        ")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "flex-width mx-1 my-1",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-yellow w-100",
                          attrs: {
                            type: "button",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.digitClick(2)
                            },
                          },
                        },
                        [_vm._v("\n          2\n        ")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "flex-width my-1",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-yellow w-100",
                          attrs: {
                            type: "button",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.digitClick(3)
                            },
                          },
                        },
                        [_vm._v("\n          3\n        ")]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex-width my-1",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-yellow w-100",
                          attrs: {
                            type: "button",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.digitClick(4)
                            },
                          },
                        },
                        [_vm._v("\n          4\n        ")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "flex-width mx-1 my-1",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-yellow w-100",
                          attrs: {
                            type: "button",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.digitClick(5)
                            },
                          },
                        },
                        [_vm._v("\n          5\n        ")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "flex-width my-1",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-yellow w-100",
                          attrs: {
                            type: "button",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.digitClick(6)
                            },
                          },
                        },
                        [_vm._v("\n          6\n        ")]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex-width my-1",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-yellow w-100",
                          attrs: {
                            type: "button",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.digitClick(7)
                            },
                          },
                        },
                        [_vm._v("\n          7\n        ")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "flex-width mx-1 my-1",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-yellow w-100",
                          attrs: {
                            type: "button",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.digitClick(8)
                            },
                          },
                        },
                        [_vm._v("\n          8\n        ")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "flex-width my-1",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-yellow w-100",
                          attrs: {
                            type: "button",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.digitClick(9)
                            },
                          },
                        },
                        [_vm._v("\n          9\n        ")]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex-width my-1",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-dark w-100",
                          attrs: {
                            type: "reset",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.digitClear()
                            },
                          },
                        },
                        [_vm._v("\n          ลบ\n        ")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "flex-width mx-1 my-1",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-yellow w-100",
                          attrs: {
                            type: "button",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.digitClick(0)
                            },
                          },
                        },
                        [_vm._v("\n          0\n        ")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "flex-width my-1",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-dark w-100",
                          attrs: {
                            type: "submit",
                          },
                          on: {
                            click: _vm.pushDigit,
                          },
                        },
                        [_vm._v("\n          เพิ่ม\n        ")]
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }